/* src/app/shared/presale-warning/presale-warning.component.scss */
.content {
  padding: 30px;
}
h3,
h4,
p {
  text-align: center;
}
.text-center {
  text-align: center;
}
ion-button::part(native) {
  padding-inline: 100px;
}
.title1 {
  font-size: 32px;
}
p.title2 {
  font-size: 20px;
}
.buttons-div {
  display: flex;
  justify-content: center;
  column-gap: 20px;
}
ion-item ion-label {
  white-space: unset !important;
  overflow: visible !important;
}
/*# sourceMappingURL=presale-warning.component-GLXY4SOU.css.map */
